import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../layoutcontainers/DashboardLayout'
import { Container, List, ListItem, ListItemText } from '@mui/material';
import MaterialTypography from '../../components/MaterialTypography';
import MaterialButton from '../../components/MaterialButton';
import MaterialBox from '../../components/MaterialBox';
import soon from '../../assest/images/project_management.png'

const Dashboard = () => {
  const [log, setLog] = useState([]);
  const [isCheckedIn, setIsCheckedIn] = useState(false);
  const [totalTime, setTotalTime] = useState(0); // Total time in seconds
  const [sessionStart, setSessionStart] = useState(null); // Start time of the current session
  const [timer, setTimer] = useState(null); // Timer interval reference

  // Function to handle check-in and check-out
  const handleCheckInOut = () => {
    const currentTime = new Date().toLocaleString();
    if (isCheckedIn) {
      // Handle check-out: stop timer, log the event, and save the current session's total time
      clearInterval(timer);
      setLog([...log, { type: 'Check Out', time: currentTime }]);
    } else {
      // Handle check-in: start/resume the timer
      setSessionStart(Date.now());
      setLog([...log, { type: 'Check In', time: currentTime }]);
      
      const newTimer = setInterval(() => {
        setTotalTime((prevTime) => prevTime + 1); // Increase the total time by 1 second every second
      }, 1000);
      setTimer(newTimer);
    }

    setIsCheckedIn(!isCheckedIn); // Toggle check-in status
  };

  // Function to format the time in HH:MM:SS
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs
      .toString()
      .padStart(2, '0')}`;
  };

  // Cleanup interval on component unmount
  useEffect(() => {
    return () => clearInterval(timer);
  }, [timer]);

  return (
    <DashboardLayout>
      <MaterialBox sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // height: '100vh', 
            }}>
                <img src={soon} alt='image not found' style={{ width: '400px', height: '400px' }} />
                <MaterialTypography variant='h2' color='dark' fontWeight='bold' sx={{ fontStyle: 'italic', fontFamily: '"Dancing Script", cursive' }}> Under Development...</MaterialTypography>
                <MaterialTypography variant='caption' color='text'>We're working hard to bring this page to life. Please check back soon.</MaterialTypography>
            </MaterialBox>
    </DashboardLayout>
  )
}

export default Dashboard


// import React, { useState, useEffect } from 'react';
// import { MaterialButton, Container, MaterialTypography, List, ListItem, ListItemText } from '@mui/material';

// const CheckInCheckOut = () => {
//   const [log, setLog] = useState([]);
//   const [isCheckedIn, setIsCheckedIn] = useState(false);
//   const [totalTime, setTotalTime] = useState(0); // Total time in seconds
//   const [sessionStart, setSessionStart] = useState(null); // Start time of the current session
//   const [timer, setTimer] = useState(null); // Timer interval reference

//   // Function to handle check-in and check-out
//   const handleCheckInOut = () => {
//     const currentTime = new Date().toLocaleString();
//     if (isCheckedIn) {
//       // Handle check-out: stop timer, log the event, and save the current session's total time
//       clearInterval(timer);
//       setLog([...log, { type: 'Check Out', time: currentTime }]);
//     } else {
//       // Handle check-in: start/resume the timer
//       setSessionStart(Date.now());
//       setLog([...log, { type: 'Check In', time: currentTime }]);
      
//       const newTimer = setInterval(() => {
//         setTotalTime((prevTime) => prevTime + 1); // Increase the total time by 1 second every second
//       }, 1000);
//       setTimer(newTimer);
//     }

//     setIsCheckedIn(!isCheckedIn); // Toggle check-in status
//   };

//   // Function to format the time in HH:MM:SS
//   const formatTime = (seconds) => {
//     const hours = Math.floor(seconds / 3600);
//     const minutes = Math.floor((seconds % 3600) / 60);
//     const secs = seconds % 60;
//     return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secs
//       .toString()
//       .padStart(2, '0')}`;
//   };

//   // Cleanup interval on component unmount
//   useEffect(() => {
//     return () => clearInterval(timer);
//   }, [timer]);

//   return (
//     <Container maxWidth="sm" sx={{ textAlign: 'center', padding: '20px' }}>
//       <MaterialTypography variant="h4" gutterBottom>
//         {isCheckedIn ? 'You are Checked In' : 'You are Checked Out'}
//       </MaterialTypography>

//       <MaterialButton
//         variant="contained"
//         color={isCheckedIn ? 'error' : 'primary'}
//         onClick={handleCheckInOut}
//         sx={{ marginBottom: '20px' }}
//       >
//         {isCheckedIn ? 'Check Out' : 'Check In'}
//       </MaterialButton>

//       <MaterialTypography variant="h6" gutterBottom>
//         Total Time Worked: {formatTime(totalTime)}
//       </MaterialTypography>

//       <MaterialTypography variant="h6" gutterBottom>
//         Activity Log:
//       </MaterialTypography>

//       <List>
//         {log.map((entry, index) => (
//           <ListItem key={index}>
//             <ListItemText primary={${entry.type} at ${entry.time}} />
//           </ListItem>
//         ))}
//       </List>
//     </Container>
//   );
// };

// export default CheckInCheckOut;
